import React from 'react'

import { compose, withProps } from 'recompose'
import styled from 'styled-components'

import GreenCheck from 'assets/icons/green_check.svg'
import { style } from 'theme'

type Props = {
  account: Account
}

type Account = {
  name: 'later' | 'invest'
  details: string[]
  recommendation: string
  type: 'IRA' | 'Portfolio'
}

export const RecommendationContainer = styled.div`
  padding: 10px 50px;
  width: 100%;
  text-align: left;
  position: relative;
  &:only-child > div {
    top: 48px !important;
  }
  &:first-child {
    padding-top: 30px;
  }
  &:first-child > div {
    top: 48px;
  }
  &:last-child {
    padding-bottom: 30px;
  }
  &: last-child > div {
    top: 27px;
  }
`

const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
`

const CheckMark = styled.div`
  width: 10px;
  height: 8px;
  background: url(${GreenCheck}) no-repeat center;
  position: absolute;
  left: 30px;
  top: 28px;
`

const RecommendedPortfolio = styled.span`
  font-size: 12px;
  font-style: italic;
  color: ${style(theme => theme.colors.stone)};
  text-transform: none;
  font-weight: normal;
`

const Detail = styled.p`
  font-size: 12px;
  color: ${style(theme => theme.colors.stone)};
  font-weight: normal;
`

const enhance = compose<any, Props>(
  withProps(({ account }) => {
    return {
      type: account.name === 'later' ? 'IRA' : 'Portfolio',
      name: account.name,
      recommendation: account.recommendation,
      details: account.details,
    }
  }),
)

const Recommendation = ({ name, details, recommendation, type }) => (
  <RecommendationContainer>
    <CheckMark />
    <Title>
      {name}
      <RecommendedPortfolio>{` — with a ${recommendation} ${type}`}</RecommendedPortfolio>
    </Title>
    {details.map((detail, index) => (
      <Detail key={index}>{detail}</Detail>
    ))}
  </RecommendationContainer>
)

export default enhance(Recommendation)
